<template>
    <div
      class="v-bottom-bar"
      style="
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        backdrop-filter: blur(10px);
        background-color: rgba(245, 245, 245, 0.8);
        border-top: 1px solid #ddd;
        z-index: 1000;
      "
      transition="fade-transition"
    >
      <v-container fluid class="pa-3">
        <v-row  justify="center" align="center">
          <v-col cols="12" sm="10" md="7" lg="4">
            <v-row justify="space-between" align="center">
              <v-col cols="auto">
                <v-btn
                  color="primary"
                  variant="flat"
                  @click="$store.commit('setShowCartDialogStatusDialogStatus', true)"
                >
                  {{ $t('cart') }}
                  ({{ $store.getters.totalCartItem}})
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  color="red"
                  variant="flat"
                  append-icon="mdi-chevron-left"
                  @click="$store.commit('setActivePage', 'order');"
                >
                {{ $t('submit_order') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
</template>
<script>
export default {
    
}
</script>